module.exports = {
  "country": "LV",
  "artist": "Triana Park",
  "song": "Line",
  "year": "2017",
  "place": "NQ",
  "spotify": "3ETIdeZcAiPQkHS1h0lyiY"
};